// Module
var code = `<div class="svc-question__adorner" data-bind="css: rootCss(), attr: { 'data-sv-drop-target-survey-element': element.name || null }, event: { dblclick: (d, e) => dblclick(e), mouseover: function(m, e) { hover(e, \$element); }, mouseleave: function(m, e) { hover(e, \$element); } }">
  <!-- ko if: \$data.showHiddenTitle -->
  <div data-bind="css: \$data.cssCollapsedHiddenHeader">
    <!-- ko if: !!\$data.element.hasTitle -->
      <!-- ko component: { name: 'survey-element-title', params: { element: \$data.element } } -->
      <!-- /ko -->
    <!-- /ko -->
    <!-- ko ifnot: !!\$data.element.hasTitle -->
      <div data-bind="css: \$data.cssCollapsedHiddenTitle">
        <span class="svc-fake-title" data-bind="text: element.name"></span>
      </div>
    <!-- /ko -->
  </div>
  <!-- /ko -->
  <div data-bind="click: koSelect, key2click: { disableTabStop: true }, clickBubble: false, css: css()">
    <div class="svc-question__drop-indicator svc-question__drop-indicator--left"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--right"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--top"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--bottom"></div>
    <!-- ko if: allowDragging -->
    <div class="svc-question__drag-area" data-bind="event: { pointerdown: (model, event)=>{ onPointerDown(event); return true; } }">
      <!-- ko component: { name: 'sv-svg-icon', params: { css: 'svc-question__drag-element', iconName: 'icon-drag-area-indicator_24x16', size: 'auto' } } -->
      <!-- /ko -->
      <div class="svc-question__top-actions">
        <!-- ko component: { name: 'sv-action-bar', params: { model: topActionContainer, handleClick: false } } -->
        <!-- /ko -->
      </div>
    </div>
    <!-- /ko -->
    <!-- ko if: \$data.needToRenderContent -->
    <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
    <!-- /ko -->
    <!-- ko if: koIsEmptyElement() && !\$data.placeholderComponentData -->
    <div class="svc-panel__placeholder_frame-wrapper">
      <div class="svc-panel__placeholder_frame">
        <div class="svc-panel__placeholder" data-bind="text: placeholderText"></div>
      </div>
    </div>
    <!-- /ko -->
    <!-- ko if: koIsEmptyElement() && !!\$data.placeholderComponentData -->
    <!-- ko let: { question: placeholderComponentData.data }  -->
    <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: placeholderComponentData } } -->
    <!-- /ko -->
    <!-- /ko -->
    <!-- /ko -->

    <!-- ko if: adornerComponent -->
    <!-- ko component: { name: adornerComponent, params: { model: \$data } } -->
    <!-- /ko -->
    <!-- /ko -->

    <!-- ko if: isBannerShowing -->
    <!-- ko component: { name: 'svc-question-banner', params: \$data } -->
    <!-- /ko -->
    <!-- /ko -->
    <div class="svc-question__content-actions" data-bind="event: {focusin: koSelect}">
      <!-- ko component: { name: 'sv-action-bar', params: { model: actionContainer, handleClick: false } } -->
      <!-- /ko -->
    </div>
    <!-- /ko -->
  </div>
</div>`;
// Exports
export default code;